require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.function.name");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./com.fulcrologic.guardrails.impl.externs.js");

require("./com.fulcrologic.guardrails.utils.js");

require("./cljs.core.async.js");

require("./cljs.spec.alpha.js");

require("./clojure.string.js");

require("./expound.alpha.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.fulcrologic.guardrails.core.js");
goog.provide('com.fulcrologic.guardrails.core');
com.fulcrologic.guardrails.core._EQ__GT_ = new cljs.core.Keyword(null, "ret", "ret", -468222814);
com.fulcrologic.guardrails.core._BAR_ = new cljs.core.Keyword(null, "st", "st", 1455255828);
com.fulcrologic.guardrails.core._LT__ = new cljs.core.Keyword(null, "gen", "gen", 142575302);
com.fulcrologic.guardrails.core.global_context = cljs.core.atom.cljs$core$IFn$_invoke$arity$1(cljs.core.List.EMPTY);
/**
 * Push a global context, accessible from all threads, onto a stack.
 * Used to add information to what guardrails will report when a function failed a check.
 */

com.fulcrologic.guardrails.core.enter_global_context_BANG_ = function com$fulcrologic$guardrails$core$enter_global_context_BANG_(ctx) {
  return cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(com.fulcrologic.guardrails.core.global_context, cljs.core.partial.cljs$core$IFn$_invoke$arity$2(cljs.core.cons, ctx));
};
/**
 * Pops a global context (see `enter-global-context!`).
 * Should be passed the same context that was pushed, although is not enforced, as it's only to be easily compatible with fulcro-spec's hooks API.
 */


com.fulcrologic.guardrails.core.leave_global_context_BANG_ = function com$fulcrologic$guardrails$core$leave_global_context_BANG_(ctx) {
  return cljs.core.swap_BANG_.cljs$core$IFn$_invoke$arity$2(com.fulcrologic.guardrails.core.global_context, cljs.core.rest);
};

com.fulcrologic.guardrails.core.get_global_context = function com$fulcrologic$guardrails$core$get_global_context() {
  return cljs.core.first(cljs.core.deref(com.fulcrologic.guardrails.core.global_context));
};

if (typeof com !== 'undefined' && typeof com.fulcrologic !== 'undefined' && typeof com.fulcrologic.guardrails !== 'undefined' && typeof com.fulcrologic.guardrails.core !== 'undefined' && typeof com.fulcrologic.guardrails.core.pending_check_channel !== 'undefined') {} else {
  com.fulcrologic.guardrails.core.pending_check_channel = cljs.core.async.chan.cljs$core$IFn$_invoke$arity$1(cljs.core.async.dropping_buffer(10000));
}

if (typeof com !== 'undefined' && typeof com.fulcrologic !== 'undefined' && typeof com.fulcrologic.guardrails !== 'undefined' && typeof com.fulcrologic.guardrails.core !== 'undefined' && typeof com.fulcrologic.guardrails.core.async_go_channel !== 'undefined') {} else {
  com.fulcrologic.guardrails.core.async_go_channel = function () {
    var c__27682__auto__ = cljs.core.async.chan.cljs$core$IFn$_invoke$arity$1(1);
    cljs.core.async.impl.dispatch.run(function () {
      var f__27683__auto__ = function () {
        var switch__27650__auto__ = function switch__27650__auto__(state_33110) {
          var state_val_33111 = state_33110[1];

          if (state_val_33111 === 7) {
            var inst_33106 = state_33110[2];
            var state_33110__$1 = state_33110;
            var statearr_33112_33157 = state_33110__$1;
            statearr_33112_33157[2] = inst_33106;
            statearr_33112_33157[1] = 4;
            return new cljs.core.Keyword(null, "recur", "recur", -437573268);
          } else {
            if (state_val_33111 === 1) {
              var state_33110__$1 = state_33110;
              return cljs.core.async.impl.ioc_helpers.take_BANG_(state_33110__$1, 2, com.fulcrologic.guardrails.core.pending_check_channel);
            } else {
              if (state_val_33111 === 4) {
                var inst_33108 = state_33110[2];
                var state_33110__$1 = state_33110;
                return cljs.core.async.impl.ioc_helpers.return_chan(state_33110__$1, inst_33108);
              } else {
                if (state_val_33111 === 6) {
                  var inst_33104 = cljs.core.println.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["Guardrails ASYNC LOOP STOPPED ****************************************"], 0));
                  var state_33110__$1 = state_33110;
                  var statearr_33113_33159 = state_33110__$1;
                  statearr_33113_33159[2] = inst_33104;
                  statearr_33113_33159[1] = 7;
                  return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                } else {
                  if (state_val_33111 === 3) {
                    var inst_33087 = state_33110[7];
                    var state_33110__$1 = state_33110;

                    if (cljs.core.truth_(inst_33087)) {
                      var statearr_33114_33160 = state_33110__$1;
                      statearr_33114_33160[1] = 5;
                    } else {
                      var statearr_33115_33161 = state_33110__$1;
                      statearr_33115_33161[1] = 6;
                    }

                    return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                  } else {
                    if (state_val_33111 === 12) {
                      var inst_33101 = state_33110[2];
                      var inst_33087 = inst_33101;

                      var state_33110__$1 = function () {
                        var statearr_33117 = state_33110;
                        statearr_33117[7] = inst_33087;
                        return statearr_33117;
                      }();

                      var statearr_33118_33162 = state_33110__$1;
                      statearr_33118_33162[2] = null;
                      statearr_33118_33162[1] = 3;
                      return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                    } else {
                      if (state_val_33111 === 2) {
                        var inst_33086 = state_33110[2];
                        var inst_33087 = inst_33086;

                        var state_33110__$1 = function () {
                          var statearr_33119 = state_33110;
                          statearr_33119[7] = inst_33087;
                          return statearr_33119;
                        }();

                        var statearr_33120_33163 = state_33110__$1;
                        statearr_33120_33163[2] = null;
                        statearr_33120_33163[1] = 3;
                        return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                      } else {
                        if (state_val_33111 === 11) {
                          var _ = function () {
                            var statearr_33121 = state_33110;
                            statearr_33121[4] = cljs.core.rest(state_33110[4]);
                            return statearr_33121;
                          }();

                          var state_33110__$1 = state_33110;
                          var ex33116 = state_33110__$1[2];
                          var statearr_33122_33164 = state_33110__$1;
                          statearr_33122_33164[5] = ex33116;
                          var statearr_33123_33165 = state_33110__$1;
                          statearr_33123_33165[1] = 10;
                          statearr_33123_33165[5] = null;
                          return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                        } else {
                          if (state_val_33111 === 9) {
                            var inst_33099 = state_33110[2];

                            var state_33110__$1 = function () {
                              var statearr_33124 = state_33110;
                              statearr_33124[8] = inst_33099;
                              return statearr_33124;
                            }();

                            return cljs.core.async.impl.ioc_helpers.take_BANG_(state_33110__$1, 12, com.fulcrologic.guardrails.core.pending_check_channel);
                          } else {
                            if (state_val_33111 === 5) {
                              var state_33110__$1 = state_33110;
                              var statearr_33125_33166 = state_33110__$1;
                              statearr_33125_33166[2] = null;
                              statearr_33125_33166[1] = 8;
                              return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                            } else {
                              if (state_val_33111 === 10) {
                                var inst_33090 = state_33110[2];

                                var state_33110__$1 = function () {
                                  var statearr_33126 = state_33110;
                                  statearr_33126[9] = inst_33090;
                                  return statearr_33126;
                                }();

                                var statearr_33127_33167 = state_33110__$1;
                                statearr_33127_33167[2] = null;
                                statearr_33127_33167[1] = 9;
                                return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                              } else {
                                if (state_val_33111 === 8) {
                                  var inst_33087 = state_33110[7];

                                  var _ = function () {
                                    var statearr_33128 = state_33110;
                                    statearr_33128[4] = cljs.core.cons(11, state_33110[4]);
                                    return statearr_33128;
                                  }();

                                  var inst_33096 = inst_33087.cljs$core$IFn$_invoke$arity$0 ? inst_33087.cljs$core$IFn$_invoke$arity$0() : inst_33087.call(null);

                                  var ___$1 = function () {
                                    var statearr_33129 = state_33110;
                                    statearr_33129[4] = cljs.core.rest(state_33110[4]);
                                    return statearr_33129;
                                  }();

                                  var state_33110__$1 = state_33110;
                                  var statearr_33130_33168 = state_33110__$1;
                                  statearr_33130_33168[2] = inst_33096;
                                  statearr_33130_33168[1] = 9;
                                  return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                                } else {
                                  return null;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };

        return function () {
          var com$fulcrologic$guardrails$core$state_machine__27651__auto__ = null;

          var com$fulcrologic$guardrails$core$state_machine__27651__auto____0 = function com$fulcrologic$guardrails$core$state_machine__27651__auto____0() {
            var statearr_33131 = [null, null, null, null, null, null, null, null, null, null];
            statearr_33131[0] = com$fulcrologic$guardrails$core$state_machine__27651__auto__;
            statearr_33131[1] = 1;
            return statearr_33131;
          };

          var com$fulcrologic$guardrails$core$state_machine__27651__auto____1 = function com$fulcrologic$guardrails$core$state_machine__27651__auto____1(state_33110) {
            while (true) {
              var ret_value__27652__auto__ = function () {
                try {
                  while (true) {
                    var result__27653__auto__ = switch__27650__auto__(state_33110);

                    if (cljs.core.keyword_identical_QMARK_(result__27653__auto__, new cljs.core.Keyword(null, "recur", "recur", -437573268))) {
                      continue;
                    } else {
                      return result__27653__auto__;
                    }

                    break;
                  }
                } catch (e33132) {
                  var ex__27654__auto__ = e33132;
                  var statearr_33133_33169 = state_33110;
                  statearr_33133_33169[2] = ex__27654__auto__;

                  if (cljs.core.seq(state_33110[4])) {
                    var statearr_33134_33170 = state_33110;
                    statearr_33134_33170[1] = cljs.core.first(state_33110[4]);
                  } else {
                    throw ex__27654__auto__;
                  }

                  return new cljs.core.Keyword(null, "recur", "recur", -437573268);
                }
              }();

              if (cljs.core.keyword_identical_QMARK_(ret_value__27652__auto__, new cljs.core.Keyword(null, "recur", "recur", -437573268))) {
                var G__33171 = state_33110;
                state_33110 = G__33171;
                continue;
              } else {
                return ret_value__27652__auto__;
              }

              break;
            }
          };

          com$fulcrologic$guardrails$core$state_machine__27651__auto__ = function com$fulcrologic$guardrails$core$state_machine__27651__auto__(state_33110) {
            switch (arguments.length) {
              case 0:
                return com$fulcrologic$guardrails$core$state_machine__27651__auto____0.call(this);

              case 1:
                return com$fulcrologic$guardrails$core$state_machine__27651__auto____1.call(this, state_33110);
            }

            throw new Error('Invalid arity: ' + arguments.length);
          };

          com$fulcrologic$guardrails$core$state_machine__27651__auto__.cljs$core$IFn$_invoke$arity$0 = com$fulcrologic$guardrails$core$state_machine__27651__auto____0;
          com$fulcrologic$guardrails$core$state_machine__27651__auto__.cljs$core$IFn$_invoke$arity$1 = com$fulcrologic$guardrails$core$state_machine__27651__auto____1;
          return com$fulcrologic$guardrails$core$state_machine__27651__auto__;
        }();
      }();

      var state__27684__auto__ = function () {
        var statearr_33135 = f__27683__auto__();
        statearr_33135[6] = c__27682__auto__;
        return statearr_33135;
      }();

      return cljs.core.async.impl.ioc_helpers.run_state_machine_wrapped(state__27684__auto__);
    });
    return c__27682__auto__;
  }();
}

com.fulcrologic.guardrails.core.output_fn = function com$fulcrologic$guardrails$core$output_fn(data) {
  var map__33136 = data;
  var map__33136__$1 = (!(map__33136 == null) ? map__33136.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__33136.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__33136) : map__33136;
  var level = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "level", "level", 1290497552));

  var _QMARK_err = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "?err", "?err", 549653299));

  var msg_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "msg_", "msg_", -1925147000));

  var _QMARK_ns_str = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "?ns-str", "?ns-str", 2012733966));

  var _QMARK_file = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "?file", "?file", 1533429675));

  var hostname_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "hostname_", "hostname_", -2091647379));
  var timestamp_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "timestamp_", "timestamp_", -954533417));

  var _QMARK_line = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33136__$1, new cljs.core.Keyword(null, "?line", "?line", -631853385));

  return [clojure.string.upper_case(cljs.core.name(level)), " ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.core.force(msg_)), function () {
    var temp__5804__auto__ = _QMARK_err;

    if (cljs.core.truth_(temp__5804__auto__)) {
      var err = temp__5804__auto__;
      return ["\n", cljs.core.str.cljs$core$IFn$_invoke$arity$1(com.fulcrologic.guardrails.utils.stacktrace.cljs$core$IFn$_invoke$arity$1(err))].join('');
    } else {
      return null;
    }
  }()].join('');
};

com.fulcrologic.guardrails.core.now_ms = function com$fulcrologic$guardrails$core$now_ms() {
  return cljs.core.inst_ms(new Date());
};

com.fulcrologic.guardrails.core.tap = typeof cljs !== 'undefined' && typeof cljs.core !== 'undefined' && typeof cljs.core.tap_GT_ !== 'undefined' ? new cljs.core.Var(function () {
  return cljs.core.tap_GT_;
}, cljs.core.with_meta(new cljs.core.Symbol("cljs.core", "tap>", "cljs.core/tap>", 895722640, null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("cljs.analyzer", "no-resolve", "cljs.analyzer/no-resolve", -1872351017), true], null)), cljs.core.PersistentHashMap.fromArrays([new cljs.core.Keyword(null, "ns", "ns", 441598760), new cljs.core.Keyword(null, "name", "name", 1843675177), new cljs.core.Keyword(null, "file", "file", -1269645878), new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), new cljs.core.Keyword(null, "column", "column", 2078222095), new cljs.core.Keyword(null, "line", "line", 212345235), new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), new cljs.core.Keyword(null, "tag", "tag", -1290361223), new cljs.core.Keyword(null, "arglists", "arglists", 1661989754), new cljs.core.Keyword(null, "doc", "doc", 1913296891), new cljs.core.Keyword(null, "test", "test", 577538877)], [new cljs.core.Symbol(null, "cljs.core", "cljs.core", 770546058, null), new cljs.core.Symbol(null, "tap>", "tap>", 1822490677, null), "cljs/core.cljs", 20, 1, 11569, 11569, new cljs.core.Symbol(null, "boolean", "boolean", -278886877, null), cljs.core.list(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "x", "x", -555367584, null)], null)), "Sends x to any taps. Returns the result of *exec-tap-fn*, a Boolean value.", cljs.core.tap_GT_ ? cljs.core.tap_GT_.cljs$lang$test : null])) : null;

com.fulcrologic.guardrails.core.run_check = function com$fulcrologic$guardrails$core$run_check(p__33138, spec, value) {
  var map__33139 = p__33138;
  var map__33139__$1 = (!(map__33139 == null) ? map__33139.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__33139.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__33139) : map__33139;
  var tap_GT__QMARK_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "tap>?", "tap>?", 212454486));
  var args_QMARK_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "args?", "args?", -1963723548));
  var vararg_QMARK_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "vararg?", "vararg?", 1908105777));
  var callsite = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "callsite", "callsite", 243654023));
  var throw_QMARK_ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "throw?", "throw?", -2036749118));
  var fn_name = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "fn-name", "fn-name", -766594004));
  var expound_opts = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__33139__$1, new cljs.core.Keyword(null, "expound-opts", "expound-opts", 623087481));
  var start_33172 = com.fulcrologic.guardrails.core.now_ms();

  var vargs_QMARK__33173 = function () {
    var and__4115__auto__ = args_QMARK_;

    if (cljs.core.truth_(and__4115__auto__)) {
      return vararg_QMARK_;
    } else {
      return and__4115__auto__;
    }
  }();

  var varg_33174 = cljs.core.truth_(vargs_QMARK__33173) ? cljs.core.last(cljs.core.seq(value)) : null;
  var specable_args_33175 = cljs.core.truth_(vargs_QMARK__33173) ? cljs.core.map_QMARK_(varg_33174) ? cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.vec(cljs.core.butlast(value)), cljs.core.flatten(cljs.core.seq(varg_33174))) : cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.vec(cljs.core.butlast(value)), cljs.core.seq(varg_33174)) : value;
  var valid_exception_33176 = cljs.core.atom.cljs$core$IFn$_invoke$arity$1(null);

  try {
    if (cljs.spec.alpha.valid_QMARK_.cljs$core$IFn$_invoke$arity$2(spec, specable_args_33175)) {} else {
      var problem_33177 = expound.alpha.expound_str.cljs$core$IFn$_invoke$arity$3(spec, specable_args_33175, expound_opts);
      var description_33178 = ["\n", cljs.core.str.cljs$core$IFn$_invoke$arity$1(fn_name), cljs.core.truth_(args_QMARK_) ? " argument list" : " return type", "\n", cljs.core.str.cljs$core$IFn$_invoke$arity$1(problem_33177)].join('');
      var context_33179 = com.fulcrologic.guardrails.core.get_global_context();

      if (cljs.core.truth_(function () {
        var and__4115__auto__ = com.fulcrologic.guardrails.core.tap;

        if (cljs.core.truth_(and__4115__auto__)) {
          return tap_GT__QMARK_;
        } else {
          return and__4115__auto__;
        }
      }())) {
        var G__33142_33180 = new cljs.core.PersistentArrayMap(null, 5, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword("com.fulcrologic.guardrails", "validation-error", "com.fulcrologic.guardrails/validation-error", 776351266), new cljs.core.Keyword("com.fulcrologic.guardrails", "fn-name", "com.fulcrologic.guardrails/fn-name", -762819408), fn_name, new cljs.core.Keyword("com.fulcrologic.guardrails", "failure-point", "com.fulcrologic.guardrails/failure-point", 340797326), cljs.core.truth_(args_QMARK_) ? new cljs.core.Keyword(null, "args", "args", 1315556576) : new cljs.core.Keyword(null, "ret", "ret", -468222814), new cljs.core.Keyword("com.fulcrologic.guardrails", "spec", "com.fulcrologic.guardrails/spec", 343160061), spec, new cljs.core.Keyword("com.fulcrologic.guardrails", "explain-data", "com.fulcrologic.guardrails/explain-data", -1120944464), cljs.spec.alpha.explain_data(spec, specable_args_33175)], null);
        com.fulcrologic.guardrails.core.tap.cljs$core$IFn$_invoke$arity$1 ? com.fulcrologic.guardrails.core.tap.cljs$core$IFn$_invoke$arity$1(G__33142_33180) : com.fulcrologic.guardrails.core.tap.call(null, G__33142_33180);
      } else {}

      if (cljs.core.truth_(throw_QMARK_)) {
        cljs.core.reset_BANG_(valid_exception_33176, cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2(function () {
          var G__33143 = description_33178;

          if (cljs.core.truth_(context_33179)) {
            return ["\nContext: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(context_33179), G__33143].join('');
          } else {
            return G__33143;
          }
        }(), cljs.core.with_meta(new cljs.core.PersistentArrayMap(null, 5, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword("com.fulcrologic.guardrails", "validation-error", "com.fulcrologic.guardrails/validation-error", 776351266), new cljs.core.Keyword("com.fulcrologic.guardrails", "fn-name", "com.fulcrologic.guardrails/fn-name", -762819408), fn_name, new cljs.core.Keyword("com.fulcrologic.guardrails", "failure-point", "com.fulcrologic.guardrails/failure-point", 340797326), cljs.core.truth_(args_QMARK_) ? new cljs.core.Keyword(null, "args", "args", 1315556576) : new cljs.core.Keyword(null, "ret", "ret", -468222814), new cljs.core.Keyword("com.fulcrologic.guardrails", "spec", "com.fulcrologic.guardrails/spec", 343160061), spec, new cljs.core.Keyword("com.fulcrologic.guardrails", "context", "com.fulcrologic.guardrails/context", -834538901), context_33179], null), new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword("com.fulcrologic.guardrails", "val", "com.fulcrologic.guardrails/val", 132345656), specable_args_33175], null))));
      } else {
        com.fulcrologic.guardrails.utils.report_problem([description_33178, "\n", cljs.core.str.cljs$core$IFn$_invoke$arity$1(com.fulcrologic.guardrails.utils.stacktrace.cljs$core$IFn$_invoke$arity$1(function () {
          var or__4126__auto__ = callsite;

          if (cljs.core.truth_(or__4126__auto__)) {
            return or__4126__auto__;
          } else {
            return cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("", cljs.core.PersistentArrayMap.EMPTY);
          }
        }()))].join(''));
      }
    }
  } catch (e33141) {
    var e_33181 = e33141;
    com.fulcrologic.guardrails.utils.report_exception(e_33181, "BUG: Internal error in expound or clojure spec.\n");
  } finally {
    var duration_33182 = com.fulcrologic.guardrails.core.now_ms() - start_33172;

    if (duration_33182 > 100) {
      com.fulcrologic.guardrails.utils.report_problem(["WARNING: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(fn_name), " ", cljs.core.truth_(args_QMARK_) ? "argument specs" : "return spec", " took ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(duration_33182), "ms to run."].join(''));
    } else {}
  }

  if (cljs.core.truth_(cljs.core.deref(valid_exception_33176))) {
    throw cljs.core.deref(valid_exception_33176);
  } else {}

  return null;
};

com.fulcrologic.guardrails.core.callsite_exception = function com$fulcrologic$guardrails$core$callsite_exception() {
  return new Error("");
};

Object.defineProperty(module.exports, "enter_global_context_BANG_", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.enter_global_context_BANG_;
  }
});
Object.defineProperty(module.exports, "tap", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.tap;
  }
});
Object.defineProperty(module.exports, "now_ms", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.now_ms;
  }
});
Object.defineProperty(module.exports, "_LT__", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core._LT__;
  }
});
Object.defineProperty(module.exports, "run_check", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.run_check;
  }
});
Object.defineProperty(module.exports, "_BAR_", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core._BAR_;
  }
});
Object.defineProperty(module.exports, "pending_check_channel", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.pending_check_channel;
  }
});
Object.defineProperty(module.exports, "async_go_channel", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.async_go_channel;
  }
});
Object.defineProperty(module.exports, "leave_global_context_BANG_", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.leave_global_context_BANG_;
  }
});
Object.defineProperty(module.exports, "global_context", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.global_context;
  }
});
Object.defineProperty(module.exports, "_EQ__GT_", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core._EQ__GT_;
  }
});
Object.defineProperty(module.exports, "callsite_exception", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.callsite_exception;
  }
});
Object.defineProperty(module.exports, "get_global_context", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.get_global_context;
  }
});
Object.defineProperty(module.exports, "output_fn", {
  enumerable: false,
  get: function get() {
    return com.fulcrologic.guardrails.core.output_fn;
  }
});